
export default {
  name: "FromEmpty",
  inheritAttrs: false,
};
